export default {
    // 中
    zhCN: {
        vin: 'VIN',
        material: '物料',
        sales_order: '销售订单',
        vehicle_type: '车型',
        shipping_area: '发运区域',
        country_of_dispatch: '发运国家',
        down_date: '下线日期',
        port_of_destination: '目的港',
        scheduled_date_of_shipment: '计划发运日期',
        actual_date_of_shipment: '实际发运日期',
        current_position: '当前位置',
        actual_arrival_date: '实际到港日期',
        retail_date: '零售日期',
    },
    // 英
    enUS: {
        vin: 'VIN',
        material: 'Vehicle material code',
        sales_order: 'Sales order',
        vehicle_type: 'Model',
        shipping_area: ' Shipping area',
        country_of_dispatch: 'Shipping country',
        down_date: 'Off-line date',
        port_of_destination: 'Port of destination',
        scheduled_date_of_shipment: 'ETD',
        actual_date_of_shipment: 'ATD',
        current_position: 'Current position',
        actual_arrival_date: 'ATA',
        retail_date: ' Retail date',
    },
    // 德
    deDE: {
        vin: 'VIN',
        material: 'Material',
        sales_order: 'Verkaufsauftrag',
        vehicle_type: 'Modell',
        shipping_area: 'Versandgebiet',
        country_of_dispatch: 'Versandland',
        down_date: 'Offline-Datum',
        port_of_destination: 'Zielhafen',
        scheduled_date_of_shipment: 'Geplantes Versanddatum',
        actual_date_of_shipment: 'Tatsächliches Versanddatum',
        current_position: 'Aktuelle Position',
        actual_arrival_date: 'Tatsächliches Ankunftsdatum',
        retail_date: 'Einzelhandelsdatum',
    },
    // 法
    frFR: {
        vin: 'VIN',
        material: 'Code véhicule',
        sales_order: 'Numéro de commande',
        vehicle_type: 'Modèle',
        shipping_area: 'Zone d\'expédition',
        country_of_dispatch: 'Pays d\'expédition',
        down_date: 'Date off-line',
        port_of_destination: 'Port de destination',
        scheduled_date_of_shipment: 'Date d\'expédition prévue',
        actual_date_of_shipment: 'Date d\'expédition réelle',
        current_position: 'Position actuelle',
        actual_arrival_date: 'Date d\'arrivée réelle',
        retail_date: 'Date de livraison',
    },
    // 意大利
    itIT: {
        vin: 'VIN',
        material: 'Materiale',
        sales_order: 'Ordine di vendita',
        vehicle_type: 'Modello',
        shipping_area: 'Zona di spedizione',
        country_of_dispatch: 'Paese di spedizione',
        down_date: 'Data fuori produzione',
        port_of_destination: 'Porto di destinazione',
        scheduled_date_of_shipment: 'ETD',
        actual_date_of_shipment: 'ATD',
        current_position: 'Posizione attuale',
        actual_arrival_date: 'ATA',
        retail_date: 'Data di vendita al dettaglio',
    },
    // 荷兰
    nlNL: {
        vin: 'VIN',
        material: 'Materiaal',
        sales_order: 'Verkooporder',
        vehicle_type: 'Model',
        shipping_area: 'Verzendgebied',
        country_of_dispatch: 'Verzendland',
        down_date: 'Offline datum',
        port_of_destination: 'Bestemmingshaven',
        scheduled_date_of_shipment: 'ETD',
        actual_date_of_shipment: 'ATD',
        current_position: 'Huidige positie',
        actual_arrival_date: 'ATA',
        retail_date: 'Verkoopdatum',
    },
    // 越南
    viVN: {
        vin: 'Số khung',
        material: 'Mã vật liệu xe',
        sales_order: 'Đơn đặt hàng bán hàng',
        vehicle_type: 'Loại xe',
        shipping_area: 'Khu vực vận chuyển',
        country_of_dispatch: 'Quốc gia vận chuyển',
        down_date: 'Ngày off-line',
        port_of_destination: 'Cảng đến',
        scheduled_date_of_shipment: 'ETD (Ngày dự kiến rời cảng)',
        actual_date_of_shipment: 'ETA (Ngày dự kiến tới)',
        current_position: 'Vị trí hiện tại',
        actual_arrival_date: 'ATA (Ngày đến thực tế)',
        retail_date: 'Ngày bán lẻ',
    },
    // 西班牙
    esES: {
        vin: 'VIN',
        material: 'Material',
        sales_order: 'Orden de venta',
        vehicle_type: 'Modelo de vehículo',
        shipping_area: 'Región de envío',
        country_of_dispatch: 'País de envío',
        down_date: 'Fecha de finalización de producción',
        port_of_destination: 'Puerto de destino',
        scheduled_date_of_shipment: 'Fecha de envío planificada',
        actual_date_of_shipment: 'Fecha de envío real',
        current_position: 'Ubicación actual',
        actual_arrival_date: 'Fecha de llegada real',
        retail_date: 'Fecha de venta al por menor',
    },
    // 葡萄牙
    ptBR: {
        vin: 'VIN',
        material: 'Material',
        sales_order: 'Pedido de venda',
        vehicle_type: 'Tipo de veículo',
        shipping_area: 'Área de envio',
        country_of_dispatch: 'País de envio',
        down_date: 'Data de desativação',
        port_of_destination: 'Porto de destino',
        scheduled_date_of_shipment: 'Data programada de envio',
        actual_date_of_shipment: 'Data real de envio',
        current_position: 'Posição atual',
        actual_arrival_date: 'Data real de chegada',
        retail_date: 'Data de venda a retalho',
    },
    // 波兰
    plPL: {
        vin: 'VIN',
        material: 'Kod materiałowy pojazdu',
        sales_order: 'Zamówienie',
        vehicle_type: 'Model',
        shipping_area: 'Obszar wysyłki',
        country_of_dispatch: 'Kraj wysyłki',
        down_date: 'Data zejścia z linii',
        port_of_destination: 'Port przeznaczenia',
        scheduled_date_of_shipment: 'Spodziwana data wysłania',
        actual_date_of_shipment: 'Rzeczywista data wysłania',
        current_position: 'Obecna lokalizacja',
        actual_arrival_date: 'Rzeczywista data dostawy do portu',
        retail_date: 'Data sprzedaży detalicznej',
    },
    // 土耳其
    trTR: {
        vin: 'VIN',
        material: 'Araç mlzeme kodu',
        sales_order: 'Satış  emri',
        vehicle_type: 'Model',
        shipping_area: 'Gönderilen bölge',
        country_of_dispatch: 'Gönderilen ülke',
        down_date: 'Devre-tışı tarih',
        port_of_destination: 'Varış limanı',
        scheduled_date_of_shipment: 'ETD',
        actual_date_of_shipment: 'ATD',
        current_position: 'Mevcut pozisyon',
        actual_arrival_date: 'ATA',
        retail_date: 'Satış tarihi',
    },
    // 捷克语
    csCZ: {
        vin: 'VIN',
        material: 'Kód materiálu vozidla',
        sales_order: 'Prodejní objednávka',
        vehicle_type: 'Model',
        shipping_area: 'Oblast expedice',
        country_of_dispatch: 'Země odeslání',
        down_date: 'Datum off-line',
        port_of_destination: 'Cílový přístav',
        scheduled_date_of_shipment: 'ETD',
        actual_date_of_shipment: 'ATD',
        current_position: 'Aktuální pozice',
        actual_arrival_date: 'ATA',
        retail_date: 'Datum prodeje',
    },
    // 匈牙利语
    huHU: {
        vin: 'Alvázszám',
        material: 'Jármű anyagkód',
        sales_order: 'Értékesítési rendelés',
        vehicle_type: 'Modell',
        shipping_area: 'Kiszállítási terület',
        country_of_dispatch: 'Kiszállítás szerinti ország',
        down_date: 'Offline dátum',
        port_of_destination: 'Célállomás',
        scheduled_date_of_shipment: 'Tervezett szállítási dátum',
        actual_date_of_shipment: 'Tényleges szállítási dátum',
        current_position: 'Jelenlegi helyzet',
        actual_arrival_date: 'Tényleges érkezési idő',
        retail_date: 'Kiskereskedelmi dátum',
    },
    // 俄罗斯语
    ruRU: {
        vin: 'VIN',
        material: 'Код материала автомобиля',
        sales_order: 'Заказ на продажу',
        vehicle_type: 'Модель',
        shipping_area: 'Регион отгрузки',
        country_of_dispatch: 'Страна отгрузки',
        down_date: 'Дата снятия с производства',
        port_of_destination: 'Порт назначения',
        scheduled_date_of_shipment: 'ETD',
        actual_date_of_shipment: 'ATD',
        current_position: 'Текущее местоположение',
        actual_arrival_date: 'ATA',
        retail_date: 'Дата розничной продажи',
    },
    // 沙特阿拉伯
    arSA: {
        vin: 'VIN',
        material: 'المادة',
        sales_order: 'طلب المبيعات',
        vehicle_type: 'نوع المركبة',
        shipping_area: 'منطقة الشحن',
        country_of_dispatch: 'دولة الإرسال',
        down_date: 'تاريخ خط التجميع',
        port_of_destination: 'ميناء الوجهة',
        scheduled_date_of_shipment: 'تاريخ الشحن المخطط',
        actual_date_of_shipment: 'تاريخ الشحن الفعلي',
        current_position: 'الموقع الحالي',
        actual_arrival_date: 'تاريخ الوصول الفعلي',
        retail_date: 'تاريخ البيع بالتجزئة',
    },
    // 保加利亚
    bgBG: {
        vin: 'VIN',
        material: 'Материал',
        sales_order: 'Поръчка за продажба',
        vehicle_type: 'Модел превозно средство',
        shipping_area: 'Зона на изпращане',
        country_of_dispatch: 'Държава на изпращане',
        down_date: 'Дата на снемане от линията',
        port_of_destination: 'Пристанище на предназначение',
        scheduled_date_of_shipment: 'Планирана дата на изпращане',
        actual_date_of_shipment: 'Фактическа дата на изпращане',
        current_position: 'Текущо местоположение',
        actual_arrival_date: 'Фактическа дата на пристигане',
        retail_date: 'Дата на дребна продажба',
    },
    // 丹麦语
    daDK: {
        vin: 'VIN',
        material: 'Materiale',
        sales_order: 'Salgsordre',
        vehicle_type: 'Køretøjstype',
        shipping_area: 'Forsendelsesområde',
        country_of_dispatch: 'Afsendelsesland',
        down_date: 'Nedlagt dato',
        port_of_destination: 'Bestemmelseshavn',
        scheduled_date_of_shipment: 'Planlagt forsendelsesdato',
        actual_date_of_shipment: 'Faktisk forsendelsesdato',
        current_position: 'Nuværende position',
        actual_arrival_date: 'Faktisk ankomstdato',
        retail_date: 'Detailhandelsdato',
    },
    // 芬兰语
    fiFI: {
        vin: 'VIN',
        material: 'Materiaali',
        sales_order: 'Myyntitilaus',
        vehicle_type: 'Ajoneuvotyyppi',
        shipping_area: 'Lähetysalue',
        country_of_dispatch: 'Lähetyksen maa',
        down_date: 'Tuotantopäivämäärä',
        port_of_destination: 'Määräsatama',
        scheduled_date_of_shipment: 'Suunniteltu lähetyspäivä',
        actual_date_of_shipment: 'Todellinen lähetyspäivä',
        current_position: 'Nykyinen sijainti',
        actual_arrival_date: 'Todellinen saapumispäivä',
        retail_date: 'Vähittäismyyntipäivä',
    },
    // 繁体中文台湾
    zhTW: {
        vin: 'VIN',
        material: '物料',
        sales_order: '銷售訂單',
        vehicle_type: '車型',
        shipping_area: '發運區域',
        country_of_dispatch: '發運國家',
        down_date: '下線日期',
        port_of_destination: '目的港',
        scheduled_date_of_shipment: '計劃發運日期',
        actual_date_of_shipment: '實際發運日期',
        current_position: '當前位置',
        actual_arrival_date: '實際到港日期',
        retail_date: '零售日期',
    },
    // 克罗地亚
    hrHR: {
        vin: 'VIN',
        material: 'Materijal',
        sales_order: 'Prodajni nalog',
        vehicle_type: 'Tip vozila',
        shipping_area: 'Područje otpreme',
        country_of_dispatch: 'Zemlja otpreme',
        down_date: 'Datum izlaska s trake',
        port_of_destination: 'Luka odredišta',
        scheduled_date_of_shipment: 'Planirani datum otpreme',
        actual_date_of_shipment: 'Stvarni datum otpreme',
        current_position: 'Trenutna lokacija',
        actual_arrival_date: 'Stvarni datum dolaska',
        retail_date: 'Datum maloprodaje',
    },
    // 拉脱维亚
    lvLV: {
        vin: 'VIN',
        material: 'Materiāls',
        sales_order: 'Pārdošanas pasūtījums',
        vehicle_type: 'Transportlīdzekļa tips',
        shipping_area: 'Piegādes apgabals',
        country_of_dispatch: 'Nosūtīšanas valsts',
        down_date: 'Ražošanas pabeigšanas datums',
        port_of_destination: 'Galamērķa osta',
        scheduled_date_of_shipment: 'Plānotais nosūtīšanas datums',
        actual_date_of_shipment: 'Faktiskais nosūtīšanas datums',
        current_position: 'Pašreizējā atrašanās vieta',
        actual_arrival_date: 'Faktiskais ierašanās datums',
        retail_date: 'Mazumtirdzniecības datums',
    },
    // 立陶宛
    ltLT: {
        vin: 'VIN',
        material: 'Medžiaga',
        sales_order: 'Pardavimo užsakymas',
        vehicle_type: 'Transporto priemonės tipas',
        shipping_area: 'Siuntimo zona',
        country_of_dispatch: 'Siuntimo šalis',
        down_date: 'Gaminto datą',
        port_of_destination: 'Paskirties uostas',
        scheduled_date_of_shipment: 'Suplanuota siuntimo data',
        actual_date_of_shipment: 'Faktinė siuntimo data',
        current_position: 'Dabartinė padėtis',
        actual_arrival_date: 'Faktinė atvykimo data',
        retail_date: 'Mažmeninės prekybos data',
    },
    // 罗马尼亚
    roRO: {
        vin: 'VIN',
        material: 'Material',
        sales_order: 'Comandă de vânzare',
        vehicle_type: 'Tip vehicul',
        shipping_area: 'Zonă de expediere',
        country_of_dispatch: 'Țara de expediție',
        down_date: 'Data ieșirii din fabricație',
        port_of_destination: 'Portul destinație',
        scheduled_date_of_shipment: 'Data planificată a expediției',
        actual_date_of_shipment: 'Data reală a expediției',
        current_position: 'Poziția curentă',
        actual_arrival_date: 'Data reală de sosire',
        retail_date: 'Data vânzării cu amănuntul',
    },
    // 挪威博克马尔
    nbNO: {
        vin: 'VIN',
        material: 'Materiale',
        sales_order: 'Salgsordre',
        vehicle_type: 'Kjøretøytype',
        shipping_area: 'Forsendelsesområde',
        country_of_dispatch: 'Avsendelsesland',
        down_date: 'Produksjonsfremdriftsdato',
        port_of_destination: 'Destinasjonshavn',
        scheduled_date_of_shipment: 'Planlagt forsendelsesdato',
        actual_date_of_shipment: 'Faktisk forsendelsesdato',
        current_position: 'Nåværende posisjon',
        actual_arrival_date: 'Faktisk ankomstdato',
        retail_date: 'Detaljhandelsdato',
    },
    // 葡萄牙语巴西
    ptBX: {
        vin: 'VIN',
        material: 'Material',
        sales_order: 'Ordem de venda',
        vehicle_type: 'Modelo do veículo',
        shipping_area: 'Área de expedição',
        country_of_dispatch: 'País de expedição',
        down_date: 'Data de finalização da produção',
        port_of_destination: 'Porto de destino',
        scheduled_date_of_shipment: 'Data programada de expedição',
        actual_date_of_shipment: 'Data real de expedição',
        current_position: 'Posição atual',
        actual_arrival_date: 'Data real de chegada',
        retail_date: 'Data de venda no varejo',
    },
    // 瑞典语
    svSE: {
        vin: 'VIN',
        material: 'Material',
        sales_order: 'Försäljningsorder',
        vehicle_type: 'Fordonstyp',
        shipping_area: 'Fraktområde',
        country_of_dispatch: 'Avsändningsland',
        down_date: 'Produktionsdatum',
        port_of_destination: 'Destinationshamn',
        scheduled_date_of_shipment: 'Planerat fraktdatum',
        actual_date_of_shipment: 'Faktiskt fraktdatum',
        current_position: 'Nuvarande position',
        actual_arrival_date: 'Faktiskt ankomstdatum',
        retail_date: 'Detaljhandelsdatum',
    },
    // 斯洛伐克
    skSK: {
        vin: 'VIN',
        material: 'Materiál',
        sales_order: 'Predajná objednávka',
        vehicle_type: 'Typ vozidla',
        shipping_area: 'Oblasť odoslania',
        country_of_dispatch: 'Krajina odoslania',
        down_date: 'Dátum ukončenia výroby',
        port_of_destination: 'Prístav určenia',
        scheduled_date_of_shipment: 'Plánovaný dátum odoslania',
        actual_date_of_shipment: 'Skutočný dátum odoslania',
        current_position: 'Aktuálna poloha',
        actual_arrival_date: 'Skutočný dátum príchodu',
        retail_date: 'Dátum predaja v maloobchode',
    },
    // 斯洛文尼亚
    slSI: {
        vin: 'VIN',
        material: 'Material',
        sales_order: 'Prodajni naročilni list',
        vehicle_type: 'Tip vozila',
        shipping_area: 'Območje pošiljanja',
        country_of_dispatch: 'Država pošiljanja',
        down_date: 'Datum končanja proizvodnje',
        port_of_destination: 'Pristanišče namembnosti',
        scheduled_date_of_shipment: 'Načrtovani datum pošiljanja',
        actual_date_of_shipment: 'Dejanski datum pošiljanja',
        current_position: 'Trenutna lokacija',
        actual_arrival_date: 'Dejanski datum prihoda',
        retail_date: 'Datum maloprodaje',
    },
    // 泰语
    thTH: {
        vin: 'VIN',
        material: 'วัสดุ',
        sales_order: 'คำสั่งขาย',
        vehicle_type: 'ประเภทรถ',
        shipping_area: 'พื้นที่จัดส่ง',
        country_of_dispatch: 'ประเทศต้นทาง',
        down_date: 'วันที่ออกจากสายการผลิต',
        port_of_destination: 'ท่าเรือปลายทาง',
        scheduled_date_of_shipment: 'วันที่จัดส่งตามแผน',
        actual_date_of_shipment: 'วันที่จัดส่งจริง',
        current_position: 'ตำแหน่งปัจจุบัน',
        actual_arrival_date: 'วันที่ถึงจริง',
        retail_date: 'วันที่ขายปลีก',
    },
    // 乌克兰语
    ukUA: {
        vin: 'VIN',
        material: 'Матеріал',
        sales_order: 'Замовлення на продаж',
        vehicle_type: 'Тип транспортного засобу',
        shipping_area: 'Зона відправлення',
        country_of_dispatch: 'Країна відправлення',
        down_date: 'Дата зняття з конвеєра',
        port_of_destination: 'Порт призначення',
        scheduled_date_of_shipment: 'Запланована дата відправлення',
        actual_date_of_shipment: 'Фактична дата відправлення',
        current_position: 'Поточне місцезнаходження',
        actual_arrival_date: 'Фактична дата прибуття',
        retail_date: 'Дата роздрібного продажу',
    },
    // 希腊语
    elGR: {
        vin: 'VIN',
        material: 'Υλικό',
        sales_order: 'Παραγγελία Πωλήσεων',
        vehicle_type: 'Τύπος Οχήματος',
        shipping_area: 'Περιοχή Αποστολής',
        country_of_dispatch: 'Χώρα Αποστολής',
        down_date: 'Ημερομηνία Κατασκευής',
        port_of_destination: 'Λιμάνι Προορισμού',
        scheduled_date_of_shipment: 'Προγραμματισμένη Ημερομηνία Αποστολής',
        actual_date_of_shipment: 'Πραγματική Ημερομηνία Αποστολής',
        current_position: 'Τρέχουσα Θέση',
        actual_arrival_date: 'Πραγματική Ημερομηνία Άφιξης',
        retail_date: 'Ημερομηνία Λιανικής Πώλησης',
    },
    // 爱沙尼亚
    etEE: {
        vin: 'VIN',
        material: 'Materjal',
        sales_order: 'Müügitellimus',
        vehicle_type: 'Sõiduki tüüp',
        shipping_area: 'Saateala',
        country_of_dispatch: 'Saatmise riik',
        down_date: 'Tootmisliini lõpetamise kuupäev',
        port_of_destination: 'Sihtsadama',
        scheduled_date_of_shipment: 'Planeeritud saatmise kuupäev',
        actual_date_of_shipment: 'Tegelik saatmise kuupäev',
        current_position: 'Praegune asukoht',
        actual_arrival_date: 'Tegelik saabumise kuupäev',
        retail_date: 'Jaekaubanduse kuupäev',
    },
    // 哈萨克
    kkKZ: {
        vin: 'VIN',
        material: 'Материал',
        sales_order: 'Сату тапсырысы',
        vehicle_type: 'Көлік түрі',
        shipping_area: 'Жіберу аймағы',
        country_of_dispatch: 'Жіберу елі',
        down_date: 'Конвейерден түсу күні',
        port_of_destination: 'Тағайындалған порт',
        scheduled_date_of_shipment: 'Жоспарланған жіберу күні',
        actual_date_of_shipment: 'Нақты жіберу күні',
        current_position: 'Ағымдағы орны',
        actual_arrival_date: 'Нақты келу күні',
        retail_date: 'Бөлшек сауда күні',
    },
    // 希伯来语
    heIL: {
        vin: 'VIN',
        material: 'חומר',
        sales_order: 'הזמנת מכירה',
        vehicle_type: 'דגם רכב',
        shipping_area: 'אזור משלוח',
        country_of_dispatch: 'מדינת המשלוח',
        down_date: 'תאריך יציאה מקו היצור',
        port_of_destination: 'נמל יעד',
        scheduled_date_of_shipment: 'תאריך משלוח מתוכנן',
        actual_date_of_shipment: 'תאריך משלוח בפועל',
        current_position: 'מיקום נוכחי',
        actual_arrival_date: 'תאריך הגעה בפועל',
        retail_date: 'תאריך מכירה בסיטונאות',
    },
};
